
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    ASSIGNED_TO_TAB_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery } from 'Core/data/GraphQLApi';
import {
    assignedToTabResult,
} from 'Redux/actions';


function* searchRoleAssignments({ payload }) {
    try {
        let QUERY = `
            query searchRoleAssignments ($roleId: Int!, $projectId: enumProjectId!, $openSearch: String, $limit: Int, $offset: Int) {
                result: searchRoleAssignments (roleId: $roleId, projectId: $projectId, openSearch: $openSearch, limit: $limit, offset: $offset) {
                    items {
                        entityName
                        label
                        username
                        email
                    }
                    total
                }
            }
        `;
        let data = yield call(
            clientQuery,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        const { items, total } = data.result
        yield put(assignedToTabResult({ items, total }))

    } catch (exc) {
        yield put(assignedToTabResult())
        ExceptionManager(
            exc,
            "Modules/packages/.components/assignedToTab/redux/saga",
            "searchRoleAssignments",
        )
    }
}

function* watchMethods() {
    yield takeEvery(ASSIGNED_TO_TAB_REQUEST, searchRoleAssignments);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}